export default "__VITE_ASSET__$WzRJODs__"